import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../utils/apiFetch"
import type { PlateConfig } from "../utils/plateCalculator"

export type TSettings = {
  plateConfig?: PlateConfig[]
  plateInventory?: Record<number, number>
  theme?: string
  showPlateCalculator?: boolean
}

export function useSettings() {
  return useQuery<TSettings>({
    queryKey: ["settings"],
    queryFn: () => apiFetch<TSettings>("/v1/settings"),
    staleTime: 5 * 60 * 1000,
  })
}

export function useUpdateSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (settings: Partial<TSettings>) =>
      apiFetch("/v1/settings", { method: "PUT", body: JSON.stringify(settings) }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings"] })
    },
  })
}
